import React, { Component } from 'react';
import '../../../src/styles/Home.css';
import '../../../src/styles/Login.css';
import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

export class EtocAccount extends Component {
    displayName = EtocAccount.name
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            username: '',
            password: '',
            errors: {},
            loginhome: false, ShowUp1: false,
            redirecttocart: false
        };
       
    }

    componentDidMount() {
      
    }

   
    render() {
      
        const meta = {
            title: "Kluwer Law Online - ETOC Account",
            canonical: window.location.href,
        }
       
        return (
            <DocumentMeta {...meta}>
                <div className="col-12">
                    <div className="White">
                    </div>
                   
                    <div className="row">
                        <div className="col-4">
                            <div className="col-lg-12 BGGrey Loginhomepadding LoginHeight logintop" >
                                <p className="LoginText franziskafont"> Login to eTOC account</p> <br></br>
                                <p className="LoginText LoginSetright">
                                    <label for="username">Email address</label>
                                    <input className="form-control BookBody" type="text" placeholder="Username" id="username" value={this.state.username} />
                                    <span className="error">{this.state.errors["username"]}</span>
                                </p>
                                <p className="LoginText LoginSetright">
                                    <label for="password">Password</label>
                                    <input type="password" className="form-control BookBody" type="password" placeholder="Password" id="password" value={this.state.password} />
                                    <span className="error">{this.state.errors["password"]}</span></p>
                                <br></br>
                               
                                <p className="LoginText LoginSetright"><a href="/" id="LoginButtonClick" className="btn btn-info next" role="button">Login</a>
                                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;<a href="/ForgotPassword" style={{ float: 'right', paddingTop: '2.5%' }}>Forgot password</a></p>

                            </div>
                           
                        </div>
                        <div className="col-4">
                            <div className="col-lg-12 BGGrey divleft LoginHeight logintop">
                                <p className="LoginText  franziskafont"> Create eTOC account</p> <br></br>
                                <p className="LoginText LoginSetright">
                                    <label for="username">Email address</label>
                                    <input className="form-control BookBody" type="text" placeholder="Username" id="username" value={this.state.username} />
                                        <span className="error">{this.state.errors["username"]}</span>
                                </p>
                                <p className="LoginText LoginSetright">
                                    <label for="password">Password</label>
                                    <input type="password" className="form-control BookBody" type="password" placeholder="Password" id="password" value={this.state.password} />
                                    <span className="error">{this.state.errors["password"]}</span></p>
                                <p className="LoginText LoginSetright">
                                    <label for="Cpassword">Confirm Password</label>
                                    <input type="password" className="form-control BookBody" placeholder="Confirm Password" id="Cpassword" value={this.state.password} />
                                        <span className="error">{this.state.errors["password"]}</span></p>
                                    <br></br>

                                    <p className="LoginText LoginSetright"><a href="/" id="LoginButtonClick" className="btn btn-info next" role="button">Create account</a>
                                    </p>
                            </div>
                        </div>

                    </div>
                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </DocumentMeta >
        );
    }
}

export default EtocAccount;


// WEBPACK FOOTER //
// ./src/components/ETOC Accounts/EtocAccount.jsx